const requestHeaderValue = {
    CONTENT_TYPE_JSON: 'application/json',
    BEARER: 'Bearer',
};

export default requestHeaderValue;
